import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { DatabaseCacheService } from "./data/cache/database-cache.service";
import { toIsoOffsetString } from "@app/core/date/date-time.util";

export function getRedirectUri(): string {
    const { hostname, origin } = window.location;

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return `${origin}/`;
    }

    // const currentLocation = window.location;
    // // ポート番号を取得
    // const port = currentLocation.port || (currentLocation.protocol === 'https:' ? '443' : '80');
    // // redirectUriを組み立て
    // return `${currentLocation.protocol}//${currentLocation.hostname}:${port}/`;

    const protocol = window.location.protocol;
    const hostWithPort = window.location.host;

    // ホスト名とポート番号を取得
    const [host, port] = hostWithPort.split(':');

    // ポート番号が存在する場合は、ホスト名とポート番号を含む形にする
    const modifiedHost = port ? `${host}:${port}` : host;

    // パスを取得
    const path = window.location.pathname;

    // パスの最初の節が '#' ではない場合は最初の節までを含む形にする
    const firstPathSegment = path.split('/')[1];
    const modifiedPath = firstPathSegment !== '#' ? path.split('/').slice(0, 2).join('/') : path;

    // 最終的なURLを構築
    const modifiedUrl = `${protocol}//${modifiedHost}${modifiedPath}`;

    return modifiedUrl;
}

export function getIsoDateTimeString(date: Date): string {
    const normalized = toIsoOffsetString(date);
    if (normalized) {
      return normalized;
    }
    // Fallback for invalid inputs
    return "";
}

export function flattenJSON(obj: any): any {
    const result: any = {};
    for (const key in obj) {
        if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
            for (const nestedKey in obj[key]) {
                result[nestedKey] = obj[key][nestedKey];
            }
        } else {
            result[key] = obj[key];
        }
    }
    return result;
}

export function getFormattedDate(dateString, format){
  // 日付けを指定のフォーマットに変換する
  // 日時はローカルPCのロケールに従う
  // 他のタイムゾーンに変更してもタイムゾーンに応じて動作することを確認済み
  try{

    const date = new Date(dateString);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    const hour = date.getHours().toString().padStart(2, "0");
    const min = date.getMinutes().toString().padStart(2, "0");
    const second = date.getSeconds().toString().padStart(2, "0");

    const millSec = date.getMilliseconds().toString().padStart(3,"0");


    const timezoneOffset = date.getTimezoneOffset() / 60;
    const offsetString = timezoneOffset < 0 ? `+${Math.abs(timezoneOffset).toString().padStart(2, '0')}:00` : `-${timezoneOffset.toString().padStart(2, '0')}:00`;

    const formattedDate = format
      .replace("yyyy", year) // 年 4桁
      .replace("mm", month) // 月 2桁
      .replace("dd", day)  // 日 2桁
      .replace("hh", hour) // 時 2桁
      .replace("nn", min) // 分 2桁
      .replace("sss", millSec) // マイクロ秒 3桁
      .replace("ss", second) // 秒 2桁
      .replace("oo", offsetString); // UTCからの時差 +09:00 みたいなやつ


    return formattedDate;
  }
  catch{
    return "-";
  }

}

export function  resetFormUntouched(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(key => {
    formGroup.controls[key].markAsUntouched();
  });
}
  
export function revalidateForm(formGroup: FormGroup){
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);
    if (control) {
      control.updateValueAndValidity();
    }
  });
}

export function clearValidatorsExcept(formGroup: FormGroup, targetFields: string[]){
  Object.keys(formGroup.controls).forEach(key => {
    if (!targetFields.includes(key)){
      const control = formGroup.get(key);
      if (control) {
        control.clearValidators();
      }  
    }
  });
}

export function passwordMatchValidator(passwordKey: string, confirmPasswordKey: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const password = formGroup.get(passwordKey)?.value;
    const confirmPassword = formGroup.get(confirmPasswordKey)?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  };
}

export function atLeastOneCheckedValidator(keys: string[],  errorPrefix: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    let atLeastOneChecked = false;
    keys.forEach(k => {
        if(formGroup.get(k)?.value){
          atLeastOneChecked = true;
        };        
      }
    )
    return atLeastOneChecked ? null : { [`${errorPrefix}_noChecks`]: true };
  };
}
